import React, { useRef, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import { setAuthData, setIsAuth } from '../../redux/auth-reducer'
import { setModal } from '../../redux/modals-reducer'
import { supabase } from '../../App'
import styled from 'styled-components'
import { useOnClickOutside } from '../../hooks/useOnClickOutside'
import { toast } from 'react-toast'
import { Links } from '../../data/categories'

const TopHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;

    .avatar img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
    }

    .left,
    .right {
        display: flex;
        align-items: center;
    }

    .left {
        width: ${(props) => (props.width ? '90%' : '80%')};
    }

    .logo {
        width: 130px;
        margin-right: 50px;
    }

    svg {
        width: 24px;
        height: 24px;
    }

    .search {
        padding: 0 16px;
        border-radius: 5px;
        width: 100%;
        background: #f2f2f6;
        display: flex;
        align-items: center;
        margin-right: 16px;
        height: 56px;
        border: 1px solid transparent;
        transition: all 0.3s ease;

        input {
            color: #333;
            font-size: 16px;
            font-weight: 500;
            width: 100%;
            margin-right: 20px;
            height: 100%;
        }

        &.focus {
            border-color: rgba(101, 81, 204, 0.5);
            box-shadow: 0 0 0 0.3rem rgba(101, 81, 204, 0.1);
        }
    }

    .icons {
        margin-left: 16px;
        display: flex;
        align-items: center;
    }

    .profile_dropdown {
        position: relative;
    }
    .dropdown {
        position: absolute;
        z-index: 2;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        background: #fff;
        padding: 10px 0;
        border-radius: 10px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        a {
            white-space: nowrap;
            padding: 0 20px;
            height: 40px;
            cursor: pointer;
            font-weight: 500;
            display: flex;
            font-size: 13px;
            align-items: center;
            transition: 0.2s all ease;
            &:hover {
                background: rgba(0, 0, 0, 0.04);
            }
            img {
                width: 16px;
                height: 16px;
                margin-right: 10px;
            }
        }
    }
`

const BottomHeader = styled.div`
    border-bottom: 1px solid #dedede;

    div {
        display: flex;
        justify-content: space-between;
        padding: 16px 0;
    }

    a {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        color: #767676;
        transition: 0.2s all ease;

        &:hover {
            color: #000;
        }
    }

    span {
        margin-left: 5px;
        padding: 0 5px;
        height: 20px;
        border-radius: 5px;
        background: #6551cc;
        color: #fff;
        font-size: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`

const Avatar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #7158eb;
    color: #fff;
    font-weight: 600;
    font-size: 13px;
    img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
    }
`

const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    width: 45px;
    height: 45px;
    transition: all 0.3s ease;

    img,
    svg {
        width: 24px;
        height: 24px;
    }

    &:first-child {
        margin-right: 5px;
    }

    &:not(.avatar):hover {
        background: #f0ebe6;
    }
`

const Buttons = styled.div`
    a {
        padding: 0 16px;
        color: #333;
        font-weight: 600;
        font-size: 16px;
        cursor: pointer;
    }
`

const Header = (props) => {
    const [showDropdown, setShowDropdown] = useState(false)
    const dispatch = useDispatch()
    const [focus, setFocus] = useState(false)
    const ref = useRef()

    const signOut = async () => {
        let { error } = await supabase.auth.signOut()
        toast.error('You just logout!')
        window.location.replace('/')
        props.setAuthData(null)
        props.setIsAuth(false)
    }

    useOnClickOutside(ref, () => setShowDropdown(false))

    let user = supabase.auth.user()

    return (
        <header className="header">
            <div className="header container">
                <TopHeader>
                    <Link to="/catalog">
                        <img
                            src="https://height.app/a/statics/assets/logo.C7N3MDIK.svg"
                            className="logo"
                            alt=""
                        />
                    </Link>
                    <div className={`search ${focus ? 'focus' : ''}`}>
                        <input
                            type="text"
                            placeholder="Search designs and products"
                            onFocus={() => setFocus(true)}
                            onBlur={() => setFocus(false)}
                        />
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                        >
                            <path d="M11 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm0-16c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z"></path>
                            <path d="M21 22c-.3 0-.5-.1-.7-.3L16 17.4c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l4.3 4.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z"></path>
                        </svg>
                    </div>
                    {!user && (
                        <Buttons>
                            <NavLink to="/seller">Продавать</NavLink>
                        </Buttons>
                    )}
                    <div className="icons">
                        {user && (
                            <div className="profile_dropdown">
                                <Icon
                                    className="avatar"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        setShowDropdown(!showDropdown)
                                    }}
                                >
                                    <img
                                        src="/images/primary/avatar.jpeg"
                                        alt=""
                                    />
                                    {/* <Avatar
                                        
                                    >
                                        {user.user_metadata.first_name
                                            .substr(0, 1)
                                            .toUpperCase()}
                                        
                                    </Avatar> */}
                                </Icon>

                                {showDropdown ? (
                                    <div className="dropdown" ref={ref}>
                                        <NavLink to="/profile">
                                            <img
                                                src="/images/primary/settings.svg"
                                                alt=""
                                            />{' '}
                                            {user.user_metadata.seller ===
                                            'seller'
                                                ? 'Панель управления'
                                                : 'Настройки'}
                                        </NavLink>
                                        <a
                                            onClick={(e) => {
                                                signOut()
                                            }}
                                        >
                                            <img
                                                src="/images/primary/logout.svg"
                                                alt=""
                                            />
                                            Выйти
                                        </a>
                                    </div>
                                ) : null}
                            </div>
                        )}
                        {!user && (
                            <Icon
                                onClick={(e) => {
                                    e.preventDefault()
                                    dispatch(setModal('AUTH'))
                                }}
                            >
                                <img src="/images/primary/user.svg" />
                            </Icon>
                        )}

                        <Icon>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path d="M12 22a1.42 1.42 0 01-.91-.34l-.09-.07-8.87-9.17C.52 10.77 0 9.72 0 8.09a6.17 6.17 0 011-3.37 5.88 5.88 0 012.65-2.25 5.74 5.74 0 013.45-.35 5.9 5.9 0 013 1.68L12 5.72l1.86-1.92a5.9 5.9 0 013-1.68 5.75 5.75 0 013.45.35A5.88 5.88 0 0123 4.72a6.17 6.17 0 011 3.37c0 1.6-.54 2.7-2.15 4.36l-8.94 9.21A1.43 1.43 0 0112 22zM5.93 4a3.65 3.65 0 00-1.49.31 3.91 3.91 0 00-1.77 1.5A4.14 4.14 0 002 8.09c0 1 .24 1.58 1.56 2.93L12 19.74l8.42-8.68C21.77 9.66 22 9 22 8.09a4.2 4.2 0 00-.67-2.29 4 4 0 00-1.77-1.49 3.7 3.7 0 00-2.25-.23 3.8 3.8 0 00-2 1.11L12 8.59l-3.3-3.4a3.8 3.8 0 00-2-1.11A3.92 3.92 0 005.93 4z"></path>
                            </svg>
                        </Icon>
                        <Icon>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                onClick={() => dispatch(setModal('CART'))}
                            >
                                <circle cx="7" cy="20" r="2"></circle>
                                <circle cx="17" cy="20" r="2"></circle>
                                <path d="M18 17H6a1 1 0 01-1-.79L2.19 3H1a1 1 0 010-2h2a1 1 0 011 .79L6.81 15h10.37l1.6-8H5a1 1 0 01-1-1c0-.55-.55-1 0-1h16a1 1 0 01.77.37 1 1 0 01.23.83l-2 10a1 1 0 01-1 .8z"></path>
                            </svg>
                        </Icon>
                    </div>
                </TopHeader>
            </div>

            <BottomHeader>
                <div className="header container">
                    {Links.map((link) => (
                        <Link to={`/catalog/${link.id}`}>{link.category}</Link>
                    ))}
                </div>
            </BottomHeader>
        </header>
    )
}

export default connect(
    (state) => ({
        cartLength: state.auth.cart.length,
        isAuth: state.auth.isAuth,
    }),
    // eslint-disable-next-line no-undef
    { setAuthData, setIsAuth }
)(Header)
